const en = {
  step: 'Step',
  form_progress: 'Form progress',
  close: 'Close',
  uploaded_files: 'Uploaded files',
  signature_drawing_area: 'Signature drawing area. Use mouse or touch to draw your signature.',
  initials_drawing_area: 'Initials drawing area. Use mouse or touch to draw your initials.',
  kba: 'KBA',
  please_upload_an_image_file: 'Please upload an image file',
  must_be_characters_length: 'Must be {number} characters long',
  must_be_valid_ssn: 'Must be a valid SSN (XXX-XX-XXXX)',
  must_be_valid_ein: 'Must be a valid EIN (XX-XXXXXXX)',
  must_be_valid_email: 'Must be a valid email address',
  must_be_valid_url: 'Must be a valid URL (starting with http:// or https://)',
  must_be_valid_zip: 'Must be a valid ZIP code (XXXXX or XXXXX-XXXX)',
  must_contain_numbers_only: 'Must contain numbers only',
  must_contain_letters_only: 'Must contain letters only',
  complete_all_required_fields_to_proceed_with_identity_verification: 'Complete all required fields to proceed with identity verification.',
  verify_id: 'Verify ID',
  identity_verification: 'Identity verification',
  complete: 'Complete',
  fill_all_required_fields_to_complete: 'Fill all required fields to complete',
  sign_and_complete: 'Sign and Complete',
  text: 'Text',
  by_clicking_you_agree_to_the: 'By clicking "{button}", you agree to the',
  electronic_signature_disclosure: 'Electronic Signature Disclosure',
  esignature_disclosure: 'eSignature Disclosure',
  signature: 'Signature',
  initials: 'Initials',
  sign_on_the_touchscreen: 'Sign on the touchscreen',
  approved: 'Approved',
  reviewed: 'Reviewed',
  other: 'Other',
  authored_by_me: 'Authored by me',
  invite: 'Invite',
  email: 'Email',
  approved_by: 'Approved by',
  reviewed_by: 'Reviewed by',
  authored_by: 'Authored by',
  select_a_reason: 'Select a reason',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scan the QR code with the camera app to open the form on mobile and draw your signature',
  date: 'Date',
  number: 'Number',
  value_is_invalid: 'Value is invalid',
  verification_code_is_invalid: 'Verification code is invalid',
  already_paid: 'Already paid',
  image: 'Image',
  pay: 'Pay',
  take_photo: 'Take photo',
  number_phone_is_invalid: '{number} phone is invalid',
  file: 'File',
  digitally_signed_by: 'Digitally signed by',
  reason: 'Reason',
  select: 'Select',
  checkbox: 'Checkbox',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cells',
  stamp: 'Stamp',
  minimize: 'Minimize',
  payment: 'Payment',
  phone: 'Phone',
  start_now: 'Start Now',
  continue: 'Continue',
  sign_now: 'Sign Now',
  type_here_: 'Type here...',
  optional: 'optional',
  option: 'Option',
  appears_on: 'Appears on',
  page: 'Page',
  select_your_option: 'Select your option',
  complete_hightlighted_checkboxes_and_click: 'Complete highlighted checkboxes and click',
  submit: 'submit',
  next: 'next',
  click_to_upload: 'Click to upload',
  or_drag_and_drop_files: 'or drag and drop files',
  send_copy_via_email: 'Send copy via email',
  download: 'Download',
  clear: 'Clear',
  redraw: 'Redraw',
  draw_initials: 'Draw initials',
  type_signature_here: 'Type signature here',
  type_initial_here: 'Type initials here',
  form_has_been_completed: 'Form has been completed!',
  document_has_been_signed: 'Document has been signed!',
  documents_have_been_signed: 'Documents have been signed!',
  create_a_free_account: 'Create a Free Account',
  powered_by: 'Powered by',
  please_check_the_box_to_continue: 'Please check the box to continue.',
  open_source_documents_software: 'open source documents software',
  verified_phone_number: 'Verify Phone Number',
  country_code: 'Country code',
  use_international_format: 'Use international format: +1xxx',
  six_digits_code: '6-digit code',
  change_phone_number: 'Change phone number',
  sending: 'Sending...',
  resend_code: 'Re-send code',
  verification_code_has_been_resent: 'Verification code has been re-sent via SMS',
  please_fill_all_required_fields: 'Please fill all required fields',
  set_today: 'Set Today',
  toggle_multiline_text: 'Toggle Multiline Text',
  draw_signature: 'Draw signature',
  type_initial: 'Type initials',
  draw: 'Draw',
  type: 'Type',
  type_text: 'Type text',
  email_has_been_sent: 'Email has been sent',
  processing: 'Processing',
  pay_with_stripe: 'Pay with Stripe',
  reupload: 'Reupload',
  upload: 'Upload',
  files: 'Files',
  signature_is_too_small_or_simple_please_redraw: 'Signature is too small or simple. Please redraw.',
  browser_privacy_settings_block_canvas: 'Your browser privacy settings restrict use of the drawing canvas. Please use a different browser or device, or disable privacy settings that block canvas in order to sign.',
  wait_countdown_seconds: 'Wait {countdown} seconds',
  enter_screen_reader_mode: 'Enter screen reader mode'
}

const es = {
  step: 'Paso',
  form_progress: 'Progreso del formulario',
  close: 'Cerrar',
  uploaded_files: 'Archivos subidos',
  signature_drawing_area: 'Área de dibujo de firma. Use el ratón o toque para dibujar su firma.',
  initials_drawing_area: 'Área de dibujo de iniciales. Use el ratón o toque para dibujar sus iniciales.',
  kba: 'KBA',
  please_upload_an_image_file: 'Por favor, sube un archivo de imagen',
  must_be_characters_length: 'Debe tener {number} caracteres de longitud',
  must_be_valid_ssn: 'Debe ser un SSN válido (XXX-XX-XXXX)',
  must_be_valid_ein: 'Debe ser un EIN válido (XX-XXXXXXX)',
  must_be_valid_email: 'Debe ser una dirección de correo electrónico válida',
  must_be_valid_url: 'Debe ser una URL válida (que comience con http:// o https://)',
  must_be_valid_zip: 'Debe ser un ZIP válido (XXXXX o XXXXX-XXXX)',
  must_contain_numbers_only: 'Debe contener solo números',
  must_contain_letters_only: 'Debe contener solo letras',
  complete_all_required_fields_to_proceed_with_identity_verification: 'Complete todos los campos requeridos para continuar con la verificación de identidad.',
  verify_id: 'Verificar ID',
  identity_verification: 'Verificación de identidad',
  complete: 'Completar',
  fill_all_required_fields_to_complete: 'Complete todos los campos requeridos para finalizar',
  sign_and_complete: 'Firmar y Completar',
  invite: 'Invitar',
  email: 'Correo electrónico',
  approved: 'Aprobado',
  reviewed: 'Revisado',
  other: 'Otro',
  authored_by_me: 'Escrito por mí',
  approved_by: 'Aprobado por',
  reviewed_by: 'Revisado por',
  authored_by: 'Escrito por',
  select_a_reason: 'Selecciona una razón',
  value_is_invalid: 'El valor no es válido',
  verification_code_is_invalid: 'El código de verificación no es válido',
  sign_on_the_touchscreen: 'Firmar en pantalla táctil',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Escanea el código QR con la aplicación de la cámara para abrir el formulario en el móvil y dibujar tu firma',
  by_clicking_you_agree_to_the: 'Al hacer clic en "{button}", usted acepta la',
  electronic_signature_disclosure: 'Divulgación de Firma Electrónica',
  esignature_disclosure: 'Divulgación de eFirma',
  already_paid: 'Ya pagado',
  minimize: 'Minimizar',
  text: 'Texto',
  signature: 'Firma',
  pay: 'Pagar',
  digitally_signed_by: 'Firmado digitalmente por',
  reason: 'Razón',
  initials: 'Iniciales',
  date: 'Fecha',
  number: 'Número',
  image: 'Imagen',
  file: 'Archivo',
  select: 'Seleccionar',
  checkbox: 'Casilla',
  number_phone_is_invalid: '{number} teléfono es inválido',
  multiple: 'Múltiple',
  radio: 'Radio',
  cells: 'Celdas',
  stamp: 'Sello',
  payment: 'Pago',
  phone: 'Teléfono',
  take_photo: 'Tomar foto',
  start_now: 'Comenzar ahora',
  continue: 'Continuar',
  sign_now: 'Firmar ahora',
  type_here_: 'Escribe aquí...',
  optional: 'opcional',
  option: 'Opción',
  appears_on: 'Aparece en',
  page: 'Página',
  select_your_option: 'Selecciona tu opción',
  complete_hightlighted_checkboxes_and_click: 'Completa las casillas resaltadas y haz clic',
  submit: 'enviar',
  next: 'siguiente',
  click_to_upload: 'Haz clic para cargar',
  or_drag_and_drop_files: 'o arrastra y suelta archivos',
  send_copy_via_email: 'Enviar copia por correo electrónico',
  download: 'Descargar',
  clear: 'Borrar',
  redraw: 'Redibujar',
  draw_initials: 'Dibujar iniciales',
  type_signature_here: 'Escribe la firma aquí',
  type_initial_here: 'Escribe las iniciales aquí',
  form_has_been_completed: '¡El formulario ha sido completado!',
  document_has_been_signed: '¡El documento ha sido firmado!',
  documents_have_been_signed: '¡Los documentos han sido firmados!',
  create_a_free_account: 'Crear una Cuenta Gratuita',
  powered_by: 'Desarrollado por',
  please_check_the_box_to_continue: 'Por favor marque la casilla para continuar.',
  open_source_documents_software: 'software de documentos de código abierto',
  verified_phone_number: 'Verificar número de teléfono',
  country_code: 'Código de país',
  use_international_format: 'Usar formato internacional: +1xxx',
  six_digits_code: 'Código de 6 dígitos',
  change_phone_number: 'Cambiar número de teléfono',
  sending: 'Enviando...',
  resend_code: 'Reenviar código',
  verification_code_has_been_resent: 'El código de verificación ha sido reenviado por SMS',
  please_fill_all_required_fields: 'Por favor, complete todos los campos obligatorios',
  set_today: 'Establecer Hoy',
  toggle_multiline_text: 'Alternar Texto Multilínea',
  draw_signature: 'Dibujar firma',
  type_initial: 'Escribir iniciales',
  draw: 'Dibujar',
  type: 'Escribir',
  type_text: 'Escribir texto',
  email_has_been_sent: 'El correo electrónico ha sido enviado',
  processing: 'Procesando',
  pay_with_stripe: 'Pagar con Stripe',
  reupload: 'Volver a subir',
  upload: 'Subir',
  files: 'Archivos',
  signature_is_too_small_or_simple_please_redraw: 'La firma es demasiado pequeña o simple. Por favor, vuelve a dibujarla.',
  browser_privacy_settings_block_canvas: 'La configuración de privacidad de su navegador restringe el uso del lienzo de dibujo. Utilice un navegador o dispositivo diferente, o desactive la configuración de privacidad que bloquea el lienzo para firmar.',
  wait_countdown_seconds: 'Espera {countdown} segundos',
  enter_screen_reader_mode: 'Activar modo lector de pantalla'
}

const it = {
  step: 'Passo',
  form_progress: 'Progresso del modulo',
  close: 'Chiudi',
  uploaded_files: 'File caricati',
  signature_drawing_area: 'Area di disegno della firma. Usa il mouse o il tocco per disegnare la tua firma.',
  initials_drawing_area: 'Area di disegno delle iniziali. Usa il mouse o il tocco per disegnare le tue iniziali.',
  kba: 'KBA',
  please_upload_an_image_file: 'Per favore carica un file immagine',
  must_be_characters_length: 'Deve essere lungo {number} caratteri',
  must_be_valid_ssn: 'Deve essere un SSN valido (XXX-XX-XXXX)',
  must_be_valid_ein: 'Deve essere un EIN valido (XX-XXXXXXX)',
  must_be_valid_email: 'Deve essere un indirizzo email valido',
  must_be_valid_url: 'Deve essere un URL valido (che inizia con http:// o https://)',
  must_be_valid_zip: 'Deve essere uno ZIP valido (XXXXX o XXXXX-XXXX)',
  must_contain_numbers_only: 'Deve contenere solo numeri',
  must_contain_letters_only: 'Deve contenere solo lettere',
  complete_all_required_fields_to_proceed_with_identity_verification: "Compila tutti i campi obbligatori per procedere con la verifica dell'identità.",
  verify_id: 'Verifica ID',
  identity_verification: "Verifica dell'identità",
  complete: 'Completa',
  fill_all_required_fields_to_complete: 'Compila tutti i campi obbligatori per completare',
  sign_and_complete: 'Firma e Completa',
  invite: 'Invita',
  email: 'Email',
  approved: 'Approvato',
  reviewed: 'Revisionato',
  other: 'Altro',
  authored_by_me: 'Creato da me',
  approved_by: 'Approvato da',
  reviewed_by: 'Revisionato da',
  authored_by: 'Creato da',
  select_a_reason: 'Seleziona una ragione',
  value_is_invalid: 'Il valore non è valido',
  verification_code_is_invalid: 'Il codice di verifica non è valido',
  sign_on_the_touchscreen: 'Firma su schermo tattile',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: "Scansiona il codice QR con l'app della fotocamera per aprire il modulo sul cellulare e disegnare la tua firma",
  by_clicking_you_agree_to_the: 'Cliccando su "{button}", accetti la',
  electronic_signature_disclosure: 'Divulgazione della Firma Elettronica',
  esignature_disclosure: 'Divulgazione della eFirma',
  minimize: 'Minimizza',
  already_paid: 'Pagato',
  text: 'Testo',
  signature: 'Firma',
  digitally_signed_by: 'Firmato digitalmente da',
  reason: 'Motivo',
  initials: 'Iniziali',
  date: 'Data',
  number: 'Numero',
  image: 'Immagine',
  pay: 'Paga',
  file: 'File',
  select: 'Seleziona',
  checkbox: 'Checkbox',
  multiple: 'Multiplo',
  radio: 'Radio',
  cells: 'Celle',
  stamp: 'Timbro',
  payment: 'Pagamento',
  number_phone_is_invalid: '{number} telefono non è valido',
  phone: 'Telefono',
  start_now: 'Inizia ora',
  continue: 'Continua',
  sign_now: 'Firma ora',
  type_here_: 'Digita qui...',
  optional: 'opzionale',
  option: 'Opzione',
  appears_on: 'Compare su',
  page: 'Pagina',
  take_photo: 'Scattare una foto',
  select_your_option: 'Seleziona la tua opzione',
  complete_hightlighted_checkboxes_and_click: 'Completa le caselle evidenziate e fai clic',
  submit: 'invia',
  next: 'avanti',
  click_to_upload: 'Clicca per caricare',
  or_drag_and_drop_files: 'oppure trascina e rilascia i file',
  send_copy_via_email: 'Invia copia via email',
  download: 'Scarica',
  clear: 'Cancella',
  redraw: 'Ridisegna',
  draw_initials: 'Disegna iniziali',
  type_signature_here: 'Scrivi la firma qui',
  type_initial_here: 'Scrivi le iniziali qui',
  form_has_been_completed: 'Il modulo è stato completato!',
  document_has_been_signed: 'Il documento è stato firmato!',
  documents_have_been_signed: 'I documenti sono stati firmati!',
  create_a_free_account: 'Crea un Account Gratuito',
  powered_by: 'Fornito da',
  please_check_the_box_to_continue: 'Si prega di spuntare la casella per continuare.',
  open_source_documents_software: 'software di documenti open source',
  verified_phone_number: 'Verifica numero di telefono',
  country_code: 'Prefisso internazionale',
  use_international_format: 'Usa formato internazionale: +1xxx',
  six_digits_code: 'Codice a 6 cifre',
  change_phone_number: 'Cambia numero di telefono',
  sending: 'Invio in corso...',
  resend_code: 'Rinvia codice',
  verification_code_has_been_resent: 'Il codice di verifica è stato rinviato tramite SMS',
  please_fill_all_required_fields: 'Si prega di compilare tutti i campi obbligatori',
  set_today: 'Imposta Oggi',
  draw_signature: 'Disegna firma',
  type_initial: 'Inserisci iniziali',
  draw: 'Disegna',
  type: 'Inserisci',
  type_text: 'Inserisci testo',
  toggle_multiline_text: 'Attiva Testo Multilinea',
  email_has_been_sent: "L'email è stata inviata",
  processing: 'Elaborazione',
  pay_with_stripe: 'Paga con Stripe',
  reupload: 'Ricarica',
  upload: 'Carica',
  files: 'File',
  signature_is_too_small_or_simple_please_redraw: 'La firma è troppo piccola o semplice. Ridisegnala, per favore.',
  browser_privacy_settings_block_canvas: 'Le impostazioni sulla privacy del browser limitano l\'uso dell\'area di disegno. Utilizza un browser o dispositivo diverso oppure disattiva le impostazioni sulla privacy che bloccano il canvas per firmare.',
  wait_countdown_seconds: 'Attendi {countdown} secondi',
  enter_screen_reader_mode: 'Attiva modalità lettore di schermo'
}

const de = {
  step: 'Schritt',
  form_progress: 'Formularfortschritt',
  close: 'Schließen',
  uploaded_files: 'Hochgeladene Dateien',
  signature_drawing_area: 'Unterschriftszeichenbereich. Verwenden Sie die Maus oder Berührung, um Ihre Unterschrift zu zeichnen.',
  initials_drawing_area: 'Zeichenbereich für Initialen. Verwenden Sie die Maus oder Berührung, um Ihre Initialen zu zeichnen.',
  kba: 'KBA',
  please_upload_an_image_file: 'Bitte laden Sie eine Bilddatei hoch',
  must_be_characters_length: 'Muss {number} Zeichen lang sein',
  must_be_valid_ssn: 'Muss eine gültige SSN sein (XXX-XX-XXXX)',
  must_be_valid_ein: 'Muss eine gültige EIN sein (XX-XXXXXXX)',
  must_be_valid_email: 'Muss eine gültige E-Mail-Adresse sein',
  must_be_valid_url: 'Muss eine gültige URL sein (beginnend mit http:// oder https://)',
  must_be_valid_zip: 'Muss eine gültige ZIP sein (XXXXX oder XXXXX-XXXX)',
  must_contain_numbers_only: 'Darf nur Zahlen enthalten',
  must_contain_letters_only: 'Darf nur Buchstaben enthalten',
  complete_all_required_fields_to_proceed_with_identity_verification: 'Füllen Sie alle Pflichtfelder aus, um mit der Identitätsprüfung fortzufahren.',
  verify_id: 'ID überprüfen',
  identity_verification: 'Identitätsprüfung',
  complete: 'Abschließen',
  fill_all_required_fields_to_complete: 'Füllen Sie alle Pflichtfelder aus, um abzuschließen',
  sign_and_complete: 'Unterzeichnen und abschließen',
  text: 'Text',
  by_clicking_you_agree_to_the: 'Durch Klicken auf "{button}" stimmen Sie dem',
  electronic_signature_disclosure: 'Hinweis zur E-Signatur',
  esignature_disclosure: 'Hinweis zur eSignatur',
  signature: 'Unterschrift',
  initials: 'Initialen',
  sign_on_the_touchscreen: 'Auf Touchscreen signieren',
  approved: 'Genehmigt',
  reviewed: 'Geprüft',
  other: 'Sonstiges',
  authored_by_me: 'Von mir erstellt',
  invite: 'Einladen',
  email: 'E-Mail',
  approved_by: 'Genehmigt von',
  reviewed_by: 'Geprüft von',
  authored_by: 'Erstellt von',
  select_a_reason: 'Grund auswählen',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scannen Sie den QR-Code mit der Kamera-App, um das Formular auf dem Mobilgerät zu öffnen und Ihre Unterschrift zu zeichnen',
  date: 'Datum',
  number: 'Zahl',
  value_is_invalid: 'Wert ist ungültig',
  verification_code_is_invalid: 'Verifizierungscode ist ungültig',
  already_paid: 'Bereits bezahlt',
  image: 'Bild',
  pay: 'Bezahlen',
  take_photo: 'Foto aufnehmen',
  number_phone_is_invalid: 'Telefonnummer ({number}) ist ungültig',
  file: 'Datei',
  digitally_signed_by: 'Elektronisch signiert von',
  reason: 'Grund',
  select: 'Auswahl',
  checkbox: 'Checkbox',
  multiple: 'Mehrfach',
  radio: 'Radio',
  cells: 'Zellen',
  stamp: 'Stempel',
  minimize: 'Minimieren',
  payment: 'Zahlung',
  phone: 'Telefon',
  start_now: 'Jetzt starten',
  continue: 'Weiter',
  sign_now: 'Jetzt unterzeichnen',
  type_here_: 'Hier eingeben...',
  optional: 'optional',
  option: 'Option',
  appears_on: 'Erscheint auf',
  page: 'Seite',
  select_your_option: 'Option auswählen',
  complete_hightlighted_checkboxes_and_click: 'Füllen Sie die markierten Kontrollkästchen aus und klicken Sie auf',
  submit: 'Einreichen',
  next: 'Weiter',
  click_to_upload: 'Zum Hochladen klicken',
  or_drag_and_drop_files: 'oder Dateien hierher ziehen und ablegen',
  send_copy_via_email: 'Kopie per E-Mail senden',
  download: 'Herunterladen',
  clear: 'Löschen',
  redraw: 'Neu zeichnen',
  draw_initials: 'Initialen zeichnen',
  type_signature_here: 'Unterschrift hier eingeben',
  type_initial_here: 'Initialen hier eingeben',
  form_has_been_completed: 'Formular wurde abgeschlossen!',
  document_has_been_signed: 'Dokument wurde unterzeichnet!',
  documents_have_been_signed: 'Dokumente wurden unterzeichnet!',
  create_a_free_account: 'Kostenloses Konto erstellen',
  powered_by: 'Bereitgestellt von',
  please_check_the_box_to_continue: 'Bitte aktivieren Sie das Kontrollkästchen, um fortzufahren.',
  open_source_documents_software: 'Open-Source-Dokumentensoftware',
  verified_phone_number: 'Telefonnummer verifizieren',
  country_code: 'Ländervorwahl',
  use_international_format: 'Internationales Format verwenden: +1xxx',
  six_digits_code: '6-stelliger Code',
  change_phone_number: 'Telefonnummer ändern',
  sending: 'Senden...',
  resend_code: 'Code erneut senden',
  verification_code_has_been_resent: 'Der Verifizierungscode wurde per SMS erneut gesendet',
  please_fill_all_required_fields: 'Bitte füllen Sie alle Pflichtfelder aus',
  set_today: 'Heute',
  toggle_multiline_text: 'Mehrzeiligen Text umschalten',
  draw_signature: 'Unterschrift zeichnen',
  type_initial: 'Initialen eingeben',
  draw: 'Zeichnen',
  type: 'Eingeben',
  type_text: 'Text eingeben',
  email_has_been_sent: 'E-Mail wurde gesendet',
  processing: 'Verarbeitung',
  pay_with_stripe: 'Mit Stripe bezahlen',
  reupload: 'Erneut hochladen',
  upload: 'Hochladen',
  files: 'Dateien',
  signature_is_too_small_or_simple_please_redraw: 'Die Unterschrift ist zu klein oder zu einfach. Bitte neu zeichnen.',
  browser_privacy_settings_block_canvas: 'Die Datenschutzeinstellungen Ihres Browsers schränken die Nutzung der Zeichenfläche ein. Bitte verwenden Sie einen anderen Browser oder ein anderes Gerät oder deaktivieren Sie die Datenschutzeinstellungen, die Canvas blockieren, um zu unterschreiben.',
  wait_countdown_seconds: 'Bitte {countdown} Sekunden warten',
  enter_screen_reader_mode: 'Screenreader-Modus aktivieren'
}

const fr = {
  step: 'Étape',
  form_progress: 'Progression du formulaire',
  close: 'Fermer',
  uploaded_files: 'Fichiers téléchargés',
  signature_drawing_area: 'Zone de dessin de signature. Utilisez la souris ou le toucher pour dessiner votre signature.',
  initials_drawing_area: 'Zone de dessin des initiales. Utilisez la souris ou le toucher pour dessiner vos initiales.',
  kba: 'KBA',
  please_upload_an_image_file: 'Veuillez téléverser un fichier image',
  must_be_characters_length: 'Doit comporter {number} caractères',
  must_be_valid_ssn: 'Doit être un SSN valide (XXX-XX-XXXX)',
  must_be_valid_ein: 'Doit être un EIN valide (XX-XXXXXXX)',
  must_be_valid_email: 'Doit être une adresse e-mail valide',
  must_be_valid_url: 'Doit être une URL valide (commençant par http:// ou https://)',
  must_be_valid_zip: 'Doit être un ZIP valide (XXXXX ou XXXXX-XXXX)',
  must_contain_numbers_only: 'Doit contenir uniquement des chiffres',
  must_contain_letters_only: 'Doit contenir uniquement des lettres',
  complete_all_required_fields_to_proceed_with_identity_verification: "Veuillez remplir tous les champs obligatoires pour poursuivre la vérification d'identité.",
  verify_id: "Vérifier l'ID",
  identity_verification: "Vérification d'identité",
  complete: 'Terminer',
  fill_all_required_fields_to_complete: 'Remplissez tous les champs obligatoires pour terminer',
  sign_and_complete: 'Signer et terminer',
  text: 'Texte',
  by_clicking_you_agree_to_the: 'En cliquant sur "{button}", vous acceptez la',
  electronic_signature_disclosure: 'Déclaration relative à la signature électronique',
  esignature_disclosure: 'Déclaration eSignature',
  signature: 'Signature',
  initials: 'Initiales',
  sign_on_the_touchscreen: 'Signer sur écran tactile',
  approved: 'Approuvé',
  reviewed: 'Révisé',
  other: 'Autre',
  authored_by_me: 'Rédigé par moi',
  invite: 'Inviter',
  email: 'E-mail',
  approved_by: 'Approuvé par',
  reviewed_by: 'Révisé par',
  authored_by: 'Rédigé par',
  select_a_reason: 'Sélectionnez une raison',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scannez le QR avec l’appareil photo pour ouvrir le formulaire et signer sur mobile',
  date: 'Date',
  number: 'Nombre',
  value_is_invalid: 'La valeur est invalide',
  verification_code_is_invalid: 'Le code de vérification est invalide',
  already_paid: 'Déjà payé',
  image: 'Image',
  pay: 'Payer',
  take_photo: 'Prendre une photo',
  number_phone_is_invalid: "Le numéro de téléphone {number} n'est pas valide",
  file: 'Fichier',
  digitally_signed_by: 'Signé électroniquement par',
  reason: 'Motif',
  select: 'Sélectionner',
  checkbox: 'Coche',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cellules',
  stamp: 'Tampon',
  minimize: 'Réduire',
  payment: 'Paiement',
  phone: 'Téléphone',
  start_now: 'Commencer maintenant',
  continue: 'Continuer',
  sign_now: 'Signer maintenant',
  type_here_: 'Saisissez ici...',
  optional: 'facultatif',
  option: 'Option',
  appears_on: 'Apparaît sur',
  page: 'Page',
  select_your_option: 'Sélectionnez votre option',
  complete_hightlighted_checkboxes_and_click: 'Cochez les cases mises en évidence puis cliquez',
  submit: 'soumettre',
  next: 'suivant',
  click_to_upload: 'Cliquez pour téléverser',
  or_drag_and_drop_files: 'ou faites glisser et déposez des fichiers',
  send_copy_via_email: 'Envoyer une copie par e-mail',
  download: 'Télécharger',
  clear: 'Effacer',
  redraw: 'Redessiner',
  draw_initials: 'Dessiner les initiales',
  type_signature_here: 'Saisissez la signature ici',
  type_initial_here: 'Saisissez les initiales ici',
  form_has_been_completed: 'Le formulaire a été rempli !',
  document_has_been_signed: 'Le document a été signé !',
  documents_have_been_signed: 'Les documents ont été signés !',
  create_a_free_account: 'Créer un compte gratuit',
  powered_by: 'Propulsé par',
  please_check_the_box_to_continue: 'Veuillez cocher la case pour continuer.',
  open_source_documents_software: 'logiciel de documents open source',
  verified_phone_number: 'Vérifier le numéro de téléphone',
  country_code: 'Indicatif du pays',
  use_international_format: 'Utilisez le format international : +1xxx',
  six_digits_code: 'Code à 6 chiffres',
  change_phone_number: 'Changer de numéro de téléphone',
  sending: 'Envoi...',
  resend_code: 'Renvoyer le code',
  verification_code_has_been_resent: 'Le code de vérification a été renvoyé par SMS',
  please_fill_all_required_fields: 'Veuillez remplir tous les champs obligatoires',
  set_today: "Définir à aujourd'hui",
  toggle_multiline_text: 'Basculer le texte multiligne',
  draw_signature: 'Dessiner la signature',
  type_initial: 'Saisir les initiales',
  draw: 'Dessiner',
  type: 'Saisir',
  type_text: 'Saisir du texte',
  email_has_been_sent: "L'e-mail a été envoyé",
  processing: 'Traitement en cours',
  pay_with_stripe: 'Payer avec Stripe',
  reupload: 'Retéléverser',
  upload: 'Téléverser',
  files: 'Fichiers',
  signature_is_too_small_or_simple_please_redraw: 'La signature est trop petite ou trop simple. Veuillez la redessiner.',
  browser_privacy_settings_block_canvas: 'Les paramètres de confidentialité de votre navigateur empêchent l\'utilisation du canevas de dessin. Veuillez utiliser un autre navigateur ou appareil, ou désactiver les paramètres de confidentialité qui bloquent le canevas pour signer.',
  wait_countdown_seconds: 'Veuillez patienter {countdown} secondes',
  enter_screen_reader_mode: 'Activer le mode lecteur d\'écran'
}

const pl = {
  step: 'Krok',
  form_progress: 'Postęp formularza',
  close: 'Zamknij',
  uploaded_files: 'Przesłane pliki',
  signature_drawing_area: 'Obszar rysowania podpisu. Użyj myszy lub dotyku, aby narysować swój podpis.',
  initials_drawing_area: 'Obszar rysowania inicjałów. Użyj myszy lub dotyku, aby narysować swoje inicjały.',
  kba: 'KBA',
  please_upload_an_image_file: 'Proszę przesłać plik obrazu',
  must_be_characters_length: 'Musi mieć długość {number} znaków',
  must_be_valid_ssn: 'Musi być prawidłowym numerem SSN (XXX-XX-XXXX)',
  must_be_valid_ein: 'Musi być prawidłowym numerem EIN (XX-XXXXXXX)',
  must_be_valid_email: 'Musi być prawidłowym adresem e-mail',
  must_be_valid_url: 'Musi być prawidłowym adresem URL (zaczynającym się od http:// lub https://)',
  must_be_valid_zip: 'Musi być prawidłowym ZIP (XXXXX lub XXXXX-XXXX)',
  must_contain_numbers_only: 'Może zawierać tylko cyfry',
  must_contain_letters_only: 'Może zawierać tylko litery',
  complete_all_required_fields_to_proceed_with_identity_verification: 'Uzupełnij wszystkie wymagane pola, aby kontynuować weryfikację tożsamości.',
  verify_id: 'Zweryfikuj ID',
  identity_verification: 'Weryfikacja tożsamości',
  complete: 'Zakończ',
  fill_all_required_fields_to_complete: 'Uzupełnij wszystkie wymagane pola, aby zakończyć',
  sign_and_complete: 'Podpisz i zakończ',
  invite: 'Zaproś',
  email: 'E-mail',
  approved: 'Zaakceptowany',
  reviewed: 'Przejrzany',
  other: 'Inny',
  authored_by_me: 'Napisane przeze mnie',
  approved_by: 'Zaakceptowany przez',
  reviewed_by: 'Przejrzany przez',
  authored_by: 'Napisane przez',
  select_a_reason: 'Wybierz powód',
  value_is_invalid: 'Wartość jest nieprawidłowa',
  verification_code_is_invalid: 'Kod weryfikacyjny jest nieprawidłowy',
  sign_on_the_touchscreen: 'Podpisz na ekranie dotykowym',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Zeskanuj kod QR za pomocą aplikacji aparatu, aby otworzyć formularz na telefonie i narysować swój podpis',
  by_clicking_you_agree_to_the: 'Klikając na "{button}", zgadzasz się na',
  electronic_signature_disclosure: 'Ujawnienie Elektronicznej Sygnatury',
  esignature_disclosure: 'informację o e-podpisie',
  minimize: 'Zminimalizuj',
  text: 'Tekst',
  already_paid: 'Już zapłacono',
  digitally_signed_by: 'Podpisano cyfrowo przez',
  reason: 'Powód',
  signature: 'Podpis',
  initials: 'Inicjały',
  date: 'Data',
  number: 'Numer',
  image: 'Obraz',
  file: 'Plik',
  pay: 'Zapłać',
  select: 'Wybierz',
  checkbox: 'Pole wyboru',
  multiple: 'Wielokrotne',
  radio: 'Radio',
  cells: 'Komórki',
  stamp: 'Pieczątka',
  payment: 'Płatność',
  number_phone_is_invalid: '{number} telefon jest nieprawidłowy',
  phone: 'Telefon',
  start_now: 'Zacznij teraz',
  continue: 'Kontynuuj',
  sign_now: 'Podpisz teraz',
  type_here_: 'Wpisz tutaj...',
  optional: 'opcjonalny',
  option: 'Opcja',
  appears_on: 'Pojawia się na',
  page: 'Strona',
  select_your_option: 'Wybierz swoją opcję',
  complete_hightlighted_checkboxes_and_click: 'Wypełnij zaznaczone pola wyboru i kliknij',
  submit: 'wyślij',
  next: 'dalej',
  take_photo: 'Zrób zdjęcie',
  click_to_upload: 'Kliknij, aby przesłać',
  or_drag_and_drop_files: 'lub przeciągnij i upuść pliki',
  send_copy_via_email: 'Wyślij kopię drogą mailową',
  download: 'Pobierz',
  clear: 'Wyczyść',
  redraw: 'Przerysuj',
  draw_initials: 'Narysuj inicjały',
  type_signature_here: 'Wpisz podpis tutaj',
  type_initial_here: 'Wpisz inicjały tutaj',
  form_has_been_completed: 'Formularz został wypełniony!',
  document_has_been_signed: 'Dokument został podpisany!',
  documents_have_been_signed: 'Dokumenty zostały podpisane!',
  create_a_free_account: 'Utwórz darmowe konto',
  powered_by: 'Napędzany przez',
  please_check_the_box_to_continue: 'Proszę zaznaczyć pole, aby kontynuować.',
  open_source_documents_software: 'oprogramowanie do dokumentów open source',
  verified_phone_number: 'Zweryfikuj numer telefonu',
  country_code: 'Kod kraju',
  use_international_format: 'Użyj międzynarodowego formatu: +1xxx',
  six_digits_code: '6-cyfrowy kod',
  change_phone_number: 'Zmień numer telefonu',
  sending: 'Wysyłanie...',
  resend_code: 'Ponownie wyślij kod',
  verification_code_has_been_resent: 'Kod weryfikacyjny został ponownie wysłany',
  please_fill_all_required_fields: 'Proszę wypełnić wszystkie wymagane pola',
  set_today: 'Ustaw Dziś',
  draw_signature: 'Rysuj podpis',
  type_initial: 'Wprowadź inicjały',
  draw: 'Rysuj',
  type: 'Wprowadź',
  type_text: 'Wprowadź tekst',
  toggle_multiline_text: 'Przełącz Tekst Wielolinijkowy',
  email_has_been_sent: 'E-mail został wysłany',
  processing: 'Przetwarzanie',
  pay_with_stripe: 'Zapłać za pomocą Stripe',
  reupload: 'Ponowne przesłanie',
  upload: 'Przesyłanie',
  files: 'Pliki',
  signature_is_too_small_or_simple_please_redraw: 'Podpis jest zbyt mały lub zbyt prosty. Proszę narysować go ponownie.',
  browser_privacy_settings_block_canvas: 'Ustawienia prywatności przeglądarki blokują użycie obszaru rysowania. Użyj innej przeglądarki lub urządzenia albo wyłącz ustawienia prywatności blokujące canvas, aby podpisać.',
  wait_countdown_seconds: 'Poczekaj {countdown} sekund',
  enter_screen_reader_mode: 'Włącz tryb czytnika ekranu'
}

const uk = {
  step: 'Крок',
  form_progress: 'Прогрес форми',
  close: 'Закрити',
  uploaded_files: 'Завантажені файли',
  signature_drawing_area: 'Область малювання підпису. Використовуйте мишу або дотик, щоб намалювати свій підпис.',
  initials_drawing_area: 'Область малювання ініціалів. Використовуйте мишу або дотик, щоб намалювати свої ініціали.',
  kba: 'KBA',
  please_upload_an_image_file: 'Будь ласка, завантажте файл зображення',
  must_be_characters_length: 'Має містити {number} символів',
  must_be_valid_ssn: 'Має бути дійсним SSN (XXX-XX-XXXX)',
  must_be_valid_ein: 'Має бути дійсним EIN (XX-XXXXXXX)',
  must_be_valid_email: 'Має бути дійсною адресою електронної пошти',
  must_be_valid_url: 'Має бути дійсним URL (починаючи з http:// або https://)',
  must_be_valid_zip: 'Має бути дійсним ZIP (XXXXX або XXXXX-XXXX)',
  must_contain_numbers_only: 'Має містити лише цифри',
  must_contain_letters_only: 'Має містити лише літери',
  complete_all_required_fields_to_proceed_with_identity_verification: "Заповніть всі обов'язкові поля, щоб продовжити перевірку особи.",
  verify_id: 'Підтвердження ідентичності',
  identity_verification: 'Ідентифікація особи',
  complete: 'Завершити',
  fill_all_required_fields_to_complete: "Заповніть всі обов'язкові поля для завершення",
  sign_and_complete: 'Підписати і завершити',
  invite: 'Запросити',
  email: 'Електронна пошта',
  approved: 'Затверджено',
  reviewed: 'Переглянуто',
  other: 'Інше',
  authored_by_me: 'Авторство моє',
  approved_by: 'Затверджено',
  reviewed_by: 'Переглянуто',
  authored_by: 'Автор',
  select_a_reason: 'Виберіть причину',
  value_is_invalid: 'Значення є неправильним',
  verification_code_is_invalid: 'Невірний код підтвердження',
  sign_on_the_touchscreen: 'Підписати на сенсорному екрані',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Скануйте QR-код за допомогою програми камери, щоб відкрити форму на мобільному пристрої та намалювати свій підпис',
  by_clicking_you_agree_to_the: 'Натиснувши на "{button}", ви погоджуєтеся з',
  electronic_signature_disclosure: 'інформацією про е-підпис',
  esignature_disclosure: 'інформацією про е-підпис',
  minimize: 'Зменшити',
  text: 'Текст',
  already_paid: 'Вже оплачено',
  signature: 'Підпис',
  digitally_signed_by: 'Підписано в електронному вигляді',
  reason: 'Причина',
  initials: 'Ініціали',
  date: 'Дата',
  number: 'Число',
  image: 'Зображення',
  pay: 'Оплатити',
  file: 'Файл',
  select: 'Вибрати',
  checkbox: 'Прапорець',
  multiple: 'Множинний',
  radio: 'Радіо',
  cells: 'Клітинки',
  stamp: 'Штамп',
  payment: 'Платіж',
  number_phone_is_invalid: '{number} телефон недійсний',
  phone: 'Телефон',
  start_now: 'Почати зараз',
  continue: 'Продовжити',
  sign_now: 'Підписати зараз',
  type_here_: 'Введіть тут',
  optional: 'необов’язково',
  option: 'Опція',
  appears_on: "З'являється на",
  page: 'Сторінка',
  take_photo: 'Зробити фото',
  select_your_option: 'Виберіть варіант',
  complete_hightlighted_checkboxes_and_click: 'Заповніть позначені прапорці та натисніть',
  submit: 'надіслати',
  next: 'далі',
  click_to_upload: 'Клацніть, щоб завантажити',
  or_drag_and_drop_files: 'або перетягніть файли сюди',
  send_copy_via_email: 'Надіслати копію електронною поштою',
  download: 'Завантажити',
  clear: 'Очистити',
  redraw: 'Перемалювати',
  draw_initials: 'Намалювати ініціали',
  type_signature_here: 'Введіть підпис тут',
  type_initial_here: 'Введіть ініціали тут',
  form_has_been_completed: 'Форму заповнено!',
  document_has_been_signed: 'Документ був підписаний!',
  documents_have_been_signed: 'Документи були підписані!',
  create_a_free_account: 'Створити безкоштовний обліковий запис',
  powered_by: 'Працює на базі',
  please_check_the_box_to_continue: 'Будь ласка, позначте прапорець, щоб продовжити.',
  open_source_documents_software: 'відкрите програмне забезпечення для документів',
  verified_phone_number: 'Підтвердіть номер телефону',
  country_code: 'Код країни',
  use_international_format: 'Використовуйте міжнародний формат: +1xxx',
  six_digits_code: '6-значний код',
  change_phone_number: 'Змінити номер телефону',
  sending: 'Надсилаю...',
  resend_code: 'Повторно відправити код',
  verification_code_has_been_resent: 'Код підтвердження був повторно надісланий',
  please_fill_all_required_fields: "Будь ласка, заповніть всі обов'язкові поля",
  set_today: 'Задати Сьогодні',
  draw_signature: 'Намалюйте підпис',
  type_initial: 'Введіть ініціали',
  draw: 'Підпис',
  type: 'Текст',
  type_text: 'Введіть текст',
  toggle_multiline_text: 'Перемкнути Багаторядковий Текст',
  email_has_been_sent: 'Електронний лист був відправлений',
  processing: 'Обробка',
  pay_with_stripe: 'Сплатити за допомогою Stripe',
  reupload: 'Перезавантажити',
  upload: 'Завантажити',
  files: 'Файли',
  signature_is_too_small_or_simple_please_redraw: 'Підпис занадто маленький або надто простий. Будь ласка, перемалюйте.',
  browser_privacy_settings_block_canvas: 'Налаштування конфіденційності вашого браузера блокують використання полотна для малювання. Будь ласка, скористайтеся іншим браузером або пристроєм, або вимкніть налаштування конфіденційності, що блокують canvas, щоб підписати.',
  wait_countdown_seconds: 'Зачекайте {countdown} секунд',
  enter_screen_reader_mode: 'Увімкнути режим читання з екрану'
}

const cs = {
  step: 'Krok',
  form_progress: 'Průběh formuláře',
  close: 'Zavřít',
  uploaded_files: 'Nahrané soubory',
  signature_drawing_area: 'Oblast pro kreslení podpisu. Použijte myš nebo dotyk k nakreslení podpisu.',
  initials_drawing_area: 'Oblast pro kreslení iniciál. Použijte myš nebo dotyk k nakreslení iniciál.',
  kba: 'KBA',
  please_upload_an_image_file: 'Nahrajte prosím obrázkový soubor',
  must_be_characters_length: 'Musí mít délku {number} znaků',
  must_be_valid_ssn: 'Musí být platné SSN (XXX-XX-XXXX)',
  must_be_valid_ein: 'Musí být platné EIN (XX-XXXXXXX)',
  must_be_valid_email: 'Musí být platná e-mailová adresa',
  must_be_valid_url: 'Musí být platná URL (začínající http:// nebo https://)',
  must_be_valid_zip: 'Musí být platný ZIP (XXXXX nebo XXXXX-XXXX)',
  must_contain_numbers_only: 'Musí obsahovat pouze čísla',
  must_contain_letters_only: 'Musí obsahovat pouze písmena',
  complete_all_required_fields_to_proceed_with_identity_verification: 'Vyplňte všechna povinná pole, abyste mohli pokračovat v ověření identity.',
  verify_id: 'Ověřit ID',
  identity_verification: 'Ověření identity',
  complete: 'Dokončit',
  fill_all_required_fields_to_complete: 'Vyplňte povinná pole pro dokončení',
  sign_and_complete: 'Podepsat a dokončit',
  invite: 'Pozvat',
  email: 'E-mail',
  approved: 'Schváleno',
  reviewed: 'Zkontrolováno',
  other: 'Jiné',
  authored_by_me: 'Autorem jsem já',
  approved_by: 'Schválil(a)',
  reviewed_by: 'Zkontroloval(a)',
  authored_by: 'Autorem',
  select_a_reason: 'Vyberte důvod',
  value_is_invalid: 'Hodnota je neplatná',
  verification_code_is_invalid: 'Ověřovací kód je neplatný',
  sign_on_the_touchscreen: 'Podepsat na dotykové obrazovce',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Naskenujte QR kód pomocí aplikace fotoaparátu, abyste otevřeli formulář na mobilním zařízení a nakreslili svůj podpis',
  by_clicking_you_agree_to_the: 'Kliknutím na "{button}" souhlasíte s',
  electronic_signature_disclosure: 'Zveřejněním Elektronického Podpisu',
  esignature_disclosure: 'informací o e-podpisu',
  already_paid: 'Už zaplaceno',
  minimize: 'Minimalizovat',
  text: 'Text',
  signature: 'Podpis',
  initials: 'Iniciály',
  date: 'Datum',
  number: 'Číslo',
  digitally_signed_by: 'Digitálně podepsáno',
  reason: 'Důvod',
  image: 'Obrázek',
  pay: 'Zaplatit',
  file: 'Soubor',
  select: 'Vybrat',
  checkbox: 'Zaškrtávací políčko',
  multiple: 'Více možností',
  radio: 'Rádio',
  cells: 'Buňky',
  stamp: 'Razítko',
  payment: 'Platba',
  phone: 'Telefon',
  number_phone_is_invalid: '{number} telefon je neplatný',
  start_now: 'Začít nyní',
  continue: 'Pokračovat',
  sign_now: 'Podepsat nyní',
  type_here_: 'Zadejte zde',
  optional: 'volitelné',
  option: 'Možnost',
  appears_on: 'Zobrazuje se na',
  page: 'Stránka',
  select_your_option: 'Vyberte svou volbu',
  take_photo: 'Fotit',
  complete_hightlighted_checkboxes_and_click: 'Označte zvýrazněné zaškrtávací políčka a klikněte na',
  submit: 'odeslat',
  next: 'další',
  click_to_upload: 'Klikněte pro nahrání',
  or_drag_and_drop_files: 'nebo přetáhněte soubory sem',
  send_copy_via_email: 'Odeslat kopii e-mailem',
  download: 'Stáhnout',
  clear: 'Smazat',
  redraw: 'Překreslit',
  draw_initials: 'Nakreslit iniciály',
  type_signature_here: 'Sem zadejte podpis',
  type_initial_here: 'Sem zadejte iniciály',
  form_has_been_completed: 'Formulář byl dokončen!',
  document_has_been_signed: 'Dokument byl podepsán!',
  documents_have_been_signed: 'Dokumenty byly podepsány!',
  create_a_free_account: 'Vytvořit bezplatný účet',
  powered_by: 'Poháněno',
  please_check_the_box_to_continue: 'Prosím, zaškrtněte políčko pro pokračování.',
  open_source_documents_software: 'open source software pro dokumenty',
  verified_phone_number: 'Ověřte telefonní číslo',
  country_code: 'Předvolba země',
  use_international_format: 'Použijte mezinárodní formát: +1xxx',
  six_digits_code: '6-místný kód',
  change_phone_number: 'Změnit telefonní číslo',
  sending: 'Odesílání...',
  resend_code: 'Znovu odeslat kód',
  verification_code_has_been_resent: 'Ověřovací kód byl znovu odeslán',
  please_fill_all_required_fields: 'Prosím vyplňte všechny povinné položky',
  set_today: 'Nastavit Dnes',
  draw_signature: 'Nakreslit podpis',
  type_initial: 'Zadat iniciály',
  draw: 'Kreslit',
  type: 'Zadat',
  type_text: 'Zadat text',
  toggle_multiline_text: 'Přepnout Víceřádkový Text',
  email_has_been_sent: 'E-mail byl odeslán',
  processing: 'Zpracování',
  pay_with_stripe: 'Zaplatit přes Stripe',
  reupload: 'Znovu nahrát',
  upload: 'Nahrát',
  files: 'Soubory',
  signature_is_too_small_or_simple_please_redraw: 'Podpis je příliš malý nebo jednoduchý. Nakreslete jej prosím znovu.',
  browser_privacy_settings_block_canvas: 'Nastavení soukromí vašeho prohlížeče omezuje použití kreslicího plátna. Použijte prosím jiný prohlížeč nebo zařízení, nebo vypněte nastavení soukromí blokující canvas pro podepsání.',
  wait_countdown_seconds: 'Počkejte {countdown} sekund',
  enter_screen_reader_mode: 'Zapnout režim čtečky obrazovky'
}

const pt = {
  step: 'Passo',
  form_progress: 'Progresso do formulário',
  close: 'Fechar',
  uploaded_files: 'Arquivos enviados',
  signature_drawing_area: 'Área de desenho da assinatura. Use o mouse ou toque para desenhar sua assinatura.',
  initials_drawing_area: 'Área de desenho das iniciais. Use o mouse ou toque para desenhar suas iniciais.',
  kba: 'KBA',
  please_upload_an_image_file: 'Por favor, envie um arquivo de imagem',
  must_be_characters_length: 'Deve ter {number} caracteres',
  must_be_valid_ssn: 'Deve ser um SSN válido (XXX-XX-XXXX)',
  must_be_valid_ein: 'Deve ser um EIN válido (XX-XXXXXXX)',
  must_be_valid_email: 'Deve ser um endereço de e-mail válido',
  must_be_valid_url: 'Deve ser uma URL válida (começando com http:// ou https://)',
  must_be_valid_zip: 'Deve ser um ZIP válido (XXXXX ou XXXXX-XXXX)',
  must_contain_numbers_only: 'Deve conter apenas números',
  must_contain_letters_only: 'Deve conter apenas letras',
  complete_all_required_fields_to_proceed_with_identity_verification: 'Preencha todos os campos obrigatórios para prosseguir com a verificação de identidade.',
  verify_id: 'Verificar ID',
  identity_verification: 'Verificação de identidade',
  complete: 'Completar',
  fill_all_required_fields_to_complete: 'Preencher todos os campos obrigatórios para concluir',
  sign_and_complete: 'Assinar e Completar',
  invite: 'Convidar',
  email: 'E-mail',
  approved: 'Aprovado',
  reviewed: 'Revisado',
  other: 'Outro',
  authored_by_me: 'Escrito por mim',
  approved_by: 'Aprovado por',
  reviewed_by: 'Revisado por',
  authored_by: 'Escrito por',
  select_a_reason: 'Selecione um motivo',
  value_is_invalid: 'Valor é inválido',
  verification_code_is_invalid: 'Código de verificação é inválido',
  sign_on_the_touchscreen: 'Assinar na tela sensível',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Escaneie o código QR com o aplicativo da câmera para abrir o formulário no celular e desenhar sua assinatura',
  by_clicking_you_agree_to_the: 'Ao clicar em "{button}", você concorda com a',
  electronic_signature_disclosure: 'Divulgação de Assinatura Eletrônica',
  esignature_disclosure: 'Informação sobre eAssinatura',
  already_paid: 'Já pago',
  minimize: 'Minimizar',
  text: 'Texto',
  signature: 'Assinatura',
  initials: 'Iniciais',
  digitally_signed_by: 'Assinado digitalmente por',
  reason: 'Razão',
  date: 'Data',
  number: 'Número',
  image: 'Imagem',
  pay: 'Pagar',
  file: 'Arquivo',
  select: 'Selecionar',
  checkbox: 'Caixa',
  multiple: 'Múltiplo',
  radio: 'Rádio',
  cells: 'Células',
  stamp: 'Carimbo',
  payment: 'Pagamento',
  number_phone_is_invalid: '{number} telefone é inválido',
  phone: 'Telefone',
  start_now: 'Começar agora',
  continue: 'Continuar',
  sign_now: 'Assinar agora',
  type_here_: 'Digite aqui',
  optional: 'opcional',
  option: 'Opção',
  appears_on: 'Aparece em',
  page: 'Página',
  take_photo: 'Tirar foto',
  select_your_option: 'Selecione sua opção',
  complete_hightlighted_checkboxes_and_click: 'Complete as caixas de seleção destacadas e clique',
  submit: 'enviar',
  next: 'próximo',
  click_to_upload: 'Clique para fazer o upload',
  or_drag_and_drop_files: 'ou arraste e solte arquivos',
  send_copy_via_email: 'Enviar cópia por e-mail',
  download: 'Baixar',
  clear: 'Limpar',
  redraw: 'Redesenhar',
  draw_initials: 'Desenhar iniciais',
  type_signature_here: 'Digite a assinatura aqui',
  type_initial_here: 'Digite as iniciais aqui',
  form_has_been_completed: 'O formulário foi concluído!',
  document_has_been_signed: 'O documento foi assinado!',
  documents_have_been_signed: 'Os documentos foram assinados!',
  create_a_free_account: 'Criar uma Conta Gratuita',
  powered_by: 'Desenvolvido por',
  please_check_the_box_to_continue: 'Por favor, marque a caixa para continuar.',
  open_source_documents_software: 'software de documentos de código aberto',
  verified_phone_number: 'Verificar Número de Telefone',
  country_code: 'Código do país',
  use_international_format: 'Use formato internacional: +1xxx',
  six_digits_code: 'Código de 6 dígitos',
  change_phone_number: 'Alterar número de telefone',
  sending: 'Enviando...',
  resend_code: 'Reenviar código',
  verification_code_has_been_resent: 'O código de verificação foi reenviado via SMS',
  please_fill_all_required_fields: 'Por favor, preencha todos os campos obrigatórios',
  set_today: 'Definir Hoje',
  draw_signature: 'Desenhar assinatura',
  type_initial: 'Inserir iniciais',
  draw: 'Desenhar',
  type: 'Inserir',
  type_text: 'Inserir texto',
  toggle_multiline_text: 'Alternar Texto Multilinha',
  email_has_been_sent: 'Email enviado',
  processing: 'Processamento',
  pay_with_stripe: 'Pagar com Stripe',
  reupload: 'Recarregar',
  upload: 'Carregar',
  files: 'Arquivos',
  signature_is_too_small_or_simple_please_redraw: 'A assinatura é muito pequena ou simples. Por favor, redesenhe.',
  browser_privacy_settings_block_canvas: 'As configurações de privacidade do seu navegador restringem o uso da área de desenho. Use um navegador ou dispositivo diferente, ou desative as configurações de privacidade que bloqueiam o canvas para assinar.',
  wait_countdown_seconds: 'Aguarde {countdown} segundos',
  enter_screen_reader_mode: 'Ativar modo leitor de tela'
}

const he = {
  step: 'שלב',
  form_progress: 'התקדמות הטופס',
  close: 'סגור',
  uploaded_files: 'קבצים שהועלו',
  signature_drawing_area: 'אזור ציור חתימה. השתמש בעכבר או במגע כדי לצייר את החתימה שלך.',
  initials_drawing_area: 'אזור ציור ראשי תיבות. השתמש בעכבר או במגע כדי לצייר את ראשי התיבות שלך.',
  kba: 'KBA',
  please_upload_an_image_file: 'אנא העלה קובץ תמונה',
  must_be_characters_length: 'חייב להיות באורך של {number} תווים',
  must_be_valid_ssn: 'חייב להיות SSN חוקי (XXX-XX-XXXX)',
  must_be_valid_ein: 'חייב להיות EIN חוקי (XX-XXXXXXX)',
  must_be_valid_email: 'חייבת להיות כתובת אימייל חוקית',
  must_be_valid_url: 'חייבת להיות כתובת URL חוקית (המתחילה ב-http:// או https://)',
  must_be_valid_zip: 'חייב להיות ZIP חוקי (XXXXX או XXXXX-XXXX)',
  must_contain_numbers_only: 'חייב להכיל מספרים בלבד',
  must_contain_letters_only: 'חייב להכיל אותיות בלבד',
  complete_all_required_fields_to_proceed_with_identity_verification: 'מלא את כל השדות הנדרשים כדי להמשיך עם אימות זהות.',
  verify_id: 'אמת מזהה',
  identity_verification: 'אימות זהות',
  complete: 'השלם',
  fill_all_required_fields_to_complete: 'נא למלא את כל השדות הנדרשים להשלמה',
  sign_and_complete: 'חתום והשלם',
  invite: 'הזמן',
  email: 'דוא"ל',
  approved: 'מאושר',
  reviewed: 'נסקר',
  other: 'אחר',
  authored_by_me: 'נכתב על ידי',
  approved_by: 'אושר על ידי',
  reviewed_by: 'נסקר על ידי',
  authored_by: 'נכתב על ידי',
  select_a_reason: 'בחר סיבה',
  value_is_invalid: 'ערך לא תקין',
  verification_code_is_invalid: 'קוד האימות אינו תקין',
  sign_on_the_touchscreen: 'חתום על מסך המגע',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'סרוק את קוד ה-QR באמצעות אפליקציית המצלמה כדי לפתוח את הטופס במובייל ולצייר את החתימה שלך',
  by_clicking_you_agree_to_the: 'על ידי לחיצה על "{button}", אתה מסכים ל',
  electronic_signature_disclosure: 'חשיפת חתימה אלקטרונית',
  esignature_disclosure: 'חשיפת חתימה אלקטרונית',
  minimize: 'מזער',
  text: 'טקסט',
  already_paid: 'כבר שולם',
  signature: 'חתימה',
  initials: 'ראשי תיבות',
  date: 'תאריך',
  digitally_signed_by: 'חתום דיגיטלית על ידי',
  reason: 'סיבה',
  number: 'מספר',
  image: 'תמונה',
  file: 'קובץ',
  pay: 'שלם',
  select: 'בחר',
  checkbox: 'סימון',
  multiple: 'רב ערכים',
  radio: 'רדיו',
  cells: 'תאים',
  stamp: 'חותמת',
  payment: 'תשלום',
  phone: 'טלפון',
  number_phone_is_invalid: '{number} טלפון אינו חוקי',
  start_now: 'התחל עכשיו',
  continue: 'המשך',
  sign_now: 'חתום כעת',
  type_here_: 'הקלד כאן',
  optional: 'אופציונלי',
  option: 'אפשרות',
  appears_on: 'מופיע ב',
  page: 'עמוד',
  take_photo: 'צלם תמונה',
  select_your_option: 'בחר את האפשרות שלך',
  complete_hightlighted_checkboxes_and_click: 'השלם את תיבות הסימון המודגשות ולחץ',
  submit: 'שליחה',
  next: 'הבא',
  click_to_upload: 'לחץ להעלאה',
  or_drag_and_drop_files: 'או גרור ושחרר קבצים',
  send_copy_via_email: 'שלח עותק באמצעות אימייל',
  download: 'הורדה',
  clear: 'נקה',
  redraw: 'צייר מחדש',
  draw_initials: 'צייר ראשי תיבות',
  type_signature_here: 'הקלד חתימה כאן',
  type_initial_here: 'הקלד ראשי תיבות כאן',
  form_has_been_completed: 'הטופס הושלם',
  document_has_been_signed: 'המסמך נחתם!',
  documents_have_been_signed: 'המסמכים נחתמו!',
  create_a_free_account: 'צור חשבון חינם',
  powered_by: 'מופעל על ידי',
  please_check_the_box_to_continue: 'אנא סמן את התיבה כדי להמשיך.',
  open_source_documents_software: 'תוכנה פתוחה למסמכים',
  verified_phone_number: 'אימות מספר טלפון',
  country_code: 'קידומת מדינה',
  use_international_format: 'השתמש בפורמט בינלאומי: +1xxx',
  six_digits_code: 'קוד שש ספרות',
  change_phone_number: 'שינוי מספר טלפון',
  sending: 'שולח',
  resend_code: 'שלח מחדש קוד',
  verification_code_has_been_resent: 'קוד האימות נשלח מחדש בSMS',
  please_fill_all_required_fields: 'אנא מלא את כל השדות הדרושים',
  set_today: 'קבע היום',
  toggle_multiline_text: 'שנה בין טקסט במספר שורות לטקסט בשורה אחת',
  draw_signature: 'צייר חתימה',
  type_initial: 'הקלד ראשי תיבות',
  draw: 'צייר',
  type: 'הקלד',
  type_text: 'הקלד טקסט',
  email_has_been_sent: 'האימייל נשלח',
  processing: 'מעבד',
  pay_with_stripe: 'שלם עם סטרייפ',
  reupload: 'העלה שוב',
  upload: 'העלאה',
  files: 'קבצים',
  signature_is_too_small_or_simple_please_redraw: 'החתימה קטנה או פשוטה מדי. אנא חתום מחדש.',
  browser_privacy_settings_block_canvas: 'הגדרות הפרטיות של הדפדפן שלך מגבילות את השימוש באזור הציור. אנא השתמש בדפדפן או מכשיר אחר, או בטל את הגדרות הפרטיות החוסמות canvas כדי לחתום.',
  wait_countdown_seconds: 'המתן {countdown} שניות',
  enter_screen_reader_mode: 'הפעל מצב קורא מסך'
}

const nl = {
  step: 'Stap',
  form_progress: 'Formuliervoortgang',
  close: 'Sluiten',
  uploaded_files: 'Geüploade bestanden',
  signature_drawing_area: 'Handtekening tekengebied. Gebruik de muis of aanraking om uw handtekening te tekenen.',
  initials_drawing_area: 'Tekengebied voor initialen. Gebruik de muis of aanraking om uw initialen te tekenen.',
  kba: 'KBA',
  please_upload_an_image_file: 'Upload alstublieft een afbeeldingsbestand',
  must_be_characters_length: 'Moet {number} tekens lang zijn',
  must_be_valid_ssn: 'Moet een geldig SSN zijn (XXX-XX-XXXX)',
  must_be_valid_ein: 'Moet een geldig EIN zijn (XX-XXXXXXX)',
  must_be_valid_email: 'Moet een geldig e-mailadres zijn',
  must_be_valid_url: 'Moet een geldige URL zijn (beginnend met http:// of https://)',
  must_be_valid_zip: 'Moet een geldige ZIP zijn (XXXXX of XXXXX-XXXX)',
  must_contain_numbers_only: 'Mag alleen cijfers bevatten',
  must_contain_letters_only: 'Mag alleen letters bevatten',
  complete_all_required_fields_to_proceed_with_identity_verification: 'Vul alle verplichte velden in om door te gaan met de identiteitsverificatie.',
  verify_id: 'ID verifiëren',
  identity_verification: 'Identiteitsverificatie',
  complete: 'Voltooien',
  fill_all_required_fields_to_complete: 'Vul alle verplichte velden in om te voltooien',
  sign_and_complete: 'Ondertekenen en voltooien',
  invite: 'Uitnodigen',
  email: 'E-mail',
  approved: 'Goedgekeurd',
  reviewed: 'Beoordeeld',
  other: 'Anders',
  authored_by_me: 'Door mij geschreven',
  approved_by: 'Goedgekeurd door',
  reviewed_by: 'Beoordeeld door',
  authored_by: 'Geschreven door',
  select_a_reason: 'Selecteer een reden',
  value_is_invalid: 'Waarde is ongeldig',
  verification_code_is_invalid: 'Verificatiecode is ongeldig',
  sign_on_the_touchscreen: 'Onderteken op touchscreen',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'Scan de QR-code met de camera-app om het formulier op mobiel te openen en uw handtekening te tekenen',
  by_clicking_you_agree_to_the: 'Door op "{button}" te klikken, gaat u akkoord met de',
  electronic_signature_disclosure: 'Openbaarmaking van Elektronische Handtekening',
  esignature_disclosure: 'Openbaarmaking van eHandtekening',
  minimize: 'Minimaliseren',
  text: 'Tekst',
  already_paid: 'Al betaald',
  signature: 'Handtekening',
  digitally_signed_by: 'Digitaal ondertekend door',
  reason: 'Reden',
  initials: 'Initialen',
  date: 'Datum',
  number: 'Nummer',
  image: 'Afbeelding',
  take_photo: 'Maak een foto',
  file: 'Bestand',
  select: 'Selecteer',
  checkbox: 'Aankruisvakje',
  multiple: 'Meerdere',
  pay: 'Betaal',
  radio: 'Radio',
  cells: 'Cellen',
  stamp: 'Stempel',
  payment: 'Betaling',
  phone: 'Telefoon',
  number_phone_is_invalid: '{number} telefoon is ongeldig',
  start_now: 'Nu beginnen',
  continue: 'Doorgaan',
  sign_now: 'Nu ondertekenen',
  type_here_: 'Typ hier...',
  optional: 'optioneel',
  option: 'Optie',
  appears_on: 'Verschijnt op',
  page: 'Pagina',
  select_your_option: 'Selecteer uw optie',
  complete_hightlighted_checkboxes_and_click: 'Voltooi de gemarkeerde selectievakjes en klik',
  submit: 'Voltooien',
  next: 'Volgende',
  click_to_upload: 'Klik om te uploaden',
  or_drag_and_drop_files: 'of sleep en plaats bestanden',
  send_copy_via_email: 'Stuur kopie per e-mail',
  download: 'Downloaden',
  clear: 'Wissen',
  redraw: 'Opnieuw tekenen',
  draw_initials: 'Initialen tekenen',
  type_signature_here: 'Typ hier uw handtekening',
  type_initial_here: 'Typ hier uw initialen',
  form_has_been_completed: 'Formulier is voltooid!',
  document_has_been_signed: 'Document is ondertekend!',
  documents_have_been_signed: 'De documenten zijn ondertekend!',
  create_a_free_account: 'Maak een gratis account aan',
  powered_by: 'Aangedreven door',
  please_check_the_box_to_continue: 'Vink het vakje aan om door te gaan.',
  open_source_documents_software: 'Open source documenten software',
  verified_phone_number: 'Telefoonnummer verifiëren',
  country_code: 'Landcode',
  use_international_format: 'Gebruik internationaal formaat: +1xxx',
  six_digits_code: '6-cijferige code',
  change_phone_number: 'Wijzig telefoonnummer',
  sending: 'Verzenden...',
  resend_code: 'Code opnieuw verzenden',
  verification_code_has_been_resent: 'Verificatiecode is opnieuw verzonden via SMS',
  please_fill_all_required_fields: 'Vul alle verplichte velden in',
  set_today: 'Vandaag',
  toggle_multiline_text: 'Schakel meerregelige tekst in/uit',
  draw_signature: 'Handtekening tekenen',
  type_initial: 'Typ initialen',
  draw: 'Tekenen',
  type: 'Typen',
  type_text: 'Typ tekst',
  email_has_been_sent: 'E-mail is verzonden',
  processing: 'Verwerken',
  pay_with_stripe: 'Betalen met Stripe',
  reupload: 'Opnieuw uploaden',
  upload: 'Uploaden',
  files: 'Bestanden',
  signature_is_too_small_or_simple_please_redraw: 'De handtekening is te klein of te eenvoudig. Teken opnieuw.',
  browser_privacy_settings_block_canvas: 'De privacyinstellingen van uw browser beperken het gebruik van het tekenveld. Gebruik een andere browser of ander apparaat, of schakel de privacyinstellingen uit die canvas blokkeren om te ondertekenen.',
  wait_countdown_seconds: 'Wacht {countdown} seconden',
  enter_screen_reader_mode: 'Schermlezer-modus inschakelen'
}

const ar = {
  step: 'خطوة',
  form_progress: 'تقدم النموذج',
  close: 'إغلاق',
  uploaded_files: 'الملفات المرفوعة',
  signature_drawing_area: 'منطقة رسم التوقيع. استخدم الماوس أو اللمس لرسم توقيعك.',
  initials_drawing_area: 'منطقة رسم الحروف الأولى. استخدم الماوس أو اللمس لرسم الحروف الأولى.',
  kba: 'KBA',
  please_upload_an_image_file: 'يرجى تحميل ملف صورة',
  must_be_characters_length: 'يجب أن يكون الطول {number} حرفًا',
  must_be_valid_ssn: 'يجب أن يكون SSN صالحًا (XXX-XX-XXXX)',
  must_be_valid_ein: 'يجب أن يكون EIN صالحًا (XX-XXXXXXX)',
  must_be_valid_email: 'يجب أن يكون عنوان بريد إلكتروني صالحًا',
  must_be_valid_url: 'يجب أن يكون عنوان URL صالحًا (يبدأ بـ http:// أو https://)',
  must_be_valid_zip: 'يجب أن يكون ZIP صالحًا (XXXXX أو XXXXX-XXXX)',
  must_contain_numbers_only: 'يجب أن يحتوي على أرقام فقط',
  must_contain_letters_only: 'يجب أن يحتوي على أحرف فقط',
  complete_all_required_fields_to_proceed_with_identity_verification: 'أكمل جميع الحقول المطلوبة للمتابعة في التحقق من الهوية.',
  verify_id: 'تحقق من الهوية',
  identity_verification: 'التحقق من الهوية',
  complete: 'اكتمال',
  fill_all_required_fields_to_complete: 'يرجى ملء جميع الحقول المطلوبة لإكمال',
  sign_and_complete: 'التوقيع والاكتمال',
  invite: 'دعوة',
  email: 'البريد الإلكتروني',
  approved: 'موافق عليه',
  reviewed: 'تمت مراجعته',
  other: 'آخر',
  authored_by_me: 'مؤلف بواسطتي',
  approved_by: 'موافق عليه من قبل',
  reviewed_by: 'مراجع من قبل',
  authored_by: 'مؤلف من قبل',
  select_a_reason: 'اختر سببًا',
  value_is_invalid: 'القيمة غير صالحة',
  verification_code_is_invalid: 'رمز التحقق غير صالح',
  already_paid: 'تم الدفع بالفعل',
  sign_on_the_touchscreen: 'وقع على شاشة اللمس',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'امسح رمز الاستجابة السريعة باستخدام تطبيق الكاميرا لفتح النموذج على الهاتف المحمول ورسم توقيعك',
  by_clicking_you_agree_to_the: 'بالنقر فوق "{button}"، أنت توافق على',
  electronic_signature_disclosure: 'كشف التوقيع الإلكتروني',
  esignature_disclosure: 'كشف التوقيع الإلكتروني',
  text: 'نص',
  signature: 'توقيع',
  initials: 'حروف أولى',
  date: 'تاريخ',
  number: 'رقم',
  digitally_signed_by: 'تم التوقيع رقميًا بواسطة',
  reason: 'السبب',
  image: 'صورة',
  take_photo: 'التقاط صورة',
  pay: 'دفع',
  file: 'ملف',
  select: 'اختيار',
  checkbox: 'خانة اختيار',
  multiple: 'متعدد',
  radio: 'راديو',
  cells: 'خلايا',
  stamp: 'ختم',
  minimize: 'تصغير',
  payment: 'الدفع',
  phone: 'هاتف',
  number_phone_is_invalid: '{number} هاتف غير صالح',
  start_now: 'ابدأ الآن',
  continue: 'متابعة',
  sign_now: 'وقع الآن',
  type_here_: 'اكتب هنا',
  optional: 'اختياري',
  option: 'خيار',
  appears_on: 'يظهر على',
  page: 'صفحة',
  select_your_option: 'اختر خيارك',
  complete_hightlighted_checkboxes_and_click: 'أكمل الخانات المميزة وانقر',
  submit: 'إرسال',
  next: 'التالي',
  click_to_upload: 'انقر للتحميل',
  or_drag_and_drop_files: 'أو اسحب وأسقط الملفات',
  send_copy_via_email: 'إرسال نسخة عبر البريد الإلكتروني',
  download: 'تحميل',
  clear: 'مسح',
  redraw: 'إعادة الرسم',
  draw_initials: 'ارسم حروف أولى',
  type_signature_here: 'اكتب التوقيع هنا',
  type_initial_here: 'اكتب حروف أولى هنا',
  form_has_been_completed: 'تم إكمال النموذج!',
  document_has_been_signed: 'تم توقيع الوثيقة!',
  documents_have_been_signed: 'تم توقيع الوثائق!',
  create_a_free_account: 'إنشاء حساب مجاني',
  powered_by: 'مدعوم من',
  please_check_the_box_to_continue: 'الرجاء التحقق من الخانة للمتابعة.',
  open_source_documents_software: 'برنامج وثائق مفتوح المصدر',
  verified_phone_number: 'تحقق من رقم الهاتف',
  country_code: 'رمز الدولة',
  use_international_format: 'استخدم الشكل الدولي: +1xxx',
  six_digits_code: 'رمز مكون من 6 أرقام',
  change_phone_number: 'تغيير رقم الهاتف',
  sending: 'جارٍ الإرسال',
  resend_code: 'إعادة إرسال الرمز',
  verification_code_has_been_resent: 'تم إعادة إرسال رمز التحقق عبر الرسائل القصيرة',
  please_fill_all_required_fields: 'الرجاء ملء جميع الحقول المطلوبة',
  set_today: 'تعيين اليوم',
  toggle_multiline_text: 'تبديل النصوص متعددة الأسطر',
  draw_signature: 'ارسم التوقيع',
  type_initial: 'اكتب حروف أولى',
  draw: 'ارسم',
  type: 'اكتب',
  type_text: 'اكتب نصًا',
  email_has_been_sent: 'تم إرسال البريد الإلكتروني',
  processing: 'جارٍ المعالجة',
  pay_with_stripe: 'الدفع بواسطة Stripe',
  reupload: 'إعادة التحميل',
  upload: 'تحميل',
  files: 'الملفات',
  signature_is_too_small_or_simple_please_redraw: 'التوقيع صغير جدًا أو بسيط جدًا. يرجى إعادة رسمه.',
  browser_privacy_settings_block_canvas: 'إعدادات الخصوصية في متصفحك تمنع استخدام لوحة الرسم. يرجى استخدام متصفح أو جهاز مختلف، أو تعطيل إعدادات الخصوصية التي تحظر canvas للتوقيع.',
  wait_countdown_seconds: 'انتظر {countdown} ثانية',
  enter_screen_reader_mode: 'تفعيل وضع قارئ الشاشة'
}

const ko = {
  step: '단계',
  form_progress: '양식 진행',
  close: '닫기',
  uploaded_files: '업로드된 파일',
  signature_drawing_area: '서명 그리기 영역. 마우스 또는 터치를 사용하여 서명을 그리세요.',
  initials_drawing_area: '이니셜 그리기 영역. 마우스 또는 터치를 사용하여 이니셜을 그리세요.',
  kba: 'KBA',
  please_upload_an_image_file: '이미지 파일을 업로드해 주세요',
  must_be_characters_length: '{number}자여야 합니다',
  must_be_valid_ssn: '유효한 SSN이어야 합니다 (XXX-XX-XXXX)',
  must_be_valid_ein: '유효한 EIN이어야 합니다 (XX-XXXXXXX)',
  must_be_valid_email: '유효한 이메일 주소여야 합니다',
  must_be_valid_url: '유효한 URL이어야 합니다 (http:// 또는 https://로 시작)',
  must_be_valid_zip: '유효한 ZIP이어야 합니다 (XXXXX 또는 XXXXX-XXXX)',
  must_contain_numbers_only: '숫자만 포함해야 합니다',
  must_contain_letters_only: '문자만 포함해야 합니다',
  complete_all_required_fields_to_proceed_with_identity_verification: '신원 확인을 진행하려면 모든 필수 필드를 작성하십시오.',
  verify_id: '아이디 확인',
  identity_verification: '신원 확인',
  complete: '완료',
  fill_all_required_fields_to_complete: '모든 필수 필드를 작성하여 완료하세요',
  sign_and_complete: '서명하고 완료하기',
  invite: '초대하기',
  email: '이메일',
  approved: '승인됨',
  reviewed: '검토됨',
  other: '기타',
  authored_by_me: '내가 작성한',
  approved_by: '승인자',
  reviewed_by: '검토자',
  authored_by: '작성자',
  select_a_reason: '이유 선택',
  sign_on_the_touchscreen: '터치스크린에서 서명',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: '카메라 앱으로 QR 코드를 스캔하여 모바일에서 양식을 열고 서명을 그리세요',
  by_clicking_you_agree_to_the: '"{button}"를 클릭함으로써, 다음에 동의하게 됩니다',
  electronic_signature_disclosure: '전자 서명 공개',
  esignature_disclosure: '전자 서명 공개',
  value_is_invalid: '값이 올바르지 않습니다',
  verification_code_is_invalid: '인증 코드가 올바르지 않습니다',
  already_paid: '이미 지불됨',
  text: '텍스트',
  signature: '서명',
  initials: '이니셜',
  date: '날짜',
  digitally_signed_by: '디지털 서명자:',
  reason: '이유',
  number: '숫자',
  pay: '결제',
  image: '이미지',
  take_photo: '사진 찍기',
  file: '파일',
  select: '선택',
  checkbox: '체크박스',
  multiple: '다중',
  radio: '라디오',
  cells: '셀',
  stamp: '스탬프',
  minimize: '최소화',
  payment: '결제',
  phone: '전화',
  number_phone_is_invalid: '{number} 전화번호가 유효하지 않습니다',
  start_now: '지금 시작하기',
  continue: '계속하다',
  sign_now: '지금 서명',
  type_here_: '여기에 입력...',
  optional: '선택 사항',
  option: '옵션',
  appears_on: '다음에 나타납니다',
  page: '페이지',
  select_your_option: '옵션 선택',
  complete_hightlighted_checkboxes_and_click: '강조된 체크박스를 완료하고 클릭',
  submit: '제출',
  next: '다음',
  click_to_upload: '업로드하려면 클릭',
  or_drag_and_drop_files: '또는 파일을 드래그하여 놓으십시오',
  send_copy_via_email: '이메일로 사본 보내기',
  download: '다운로드',
  clear: '지우기',
  redraw: '다시 그리기',
  draw_initials: '이니셜 그리기',
  type_signature_here: '여기에 서명 입력',
  type_initial_here: '여기에 이니셜 입력',
  form_has_been_completed: '양식이 완료되었습니다!',
  document_has_been_signed: '문서가 서명되었습니다!',
  documents_have_been_signed: '문서가 서명되었습니다!',
  create_a_free_account: '무료 계정 생성',
  powered_by: '구동',
  please_check_the_box_to_continue: '계속하려면 확인란을 선택하십시오.',
  open_source_documents_software: '오픈 소스 문서 소프트웨어',
  verified_phone_number: '전화번호 확인됨',
  country_code: '국가 번호',
  use_international_format: '국제 포맷 사용: +1xxx',
  six_digits_code: '6자리 코드',
  change_phone_number: '전화번호 변경',
  sending: '전송 중...',
  resend_code: '코드 다시 보내기',
  verification_code_has_been_resent: '인증 코드가 SMS로 다시 전송되었습니다',
  please_fill_all_required_fields: '필수 필드를 모두 입력하십시오',
  set_today: '오늘 날짜로 설정',
  toggle_multiline_text: '다중 텍스트 전환',
  draw_signature: '서명 그리기',
  type_initial: '이니셜 입력',
  draw: '그리기',
  type: '입력',
  type_text: '텍스트 입력',
  email_has_been_sent: '이메일이 전송되었습니다',
  processing: '처리 중',
  pay_with_stripe: '스트라이프로 결제',
  reupload: '다시 업로드',
  upload: '업로드',
  files: '파일',
  signature_is_too_small_or_simple_please_redraw: '서명이 너무 작거나 단순합니다. 다시 그려주세요.',
  browser_privacy_settings_block_canvas: '브라우저 개인정보 보호 설정으로 인해 그리기 캔버스를 사용할 수 없습니다. 다른 브라우저나 기기를 사용하거나, 서명을 위해 캔버스를 차단하는 개인정보 보호 설정을 비활성화해 주세요.',
  wait_countdown_seconds: '{countdown}초 기다리세요',
  enter_screen_reader_mode: '스크린 리더 모드 활성화'
}

const ja = {
  step: 'ステップ',
  form_progress: 'フォームの進捗',
  close: '閉じる',
  uploaded_files: 'アップロードされたファイル',
  signature_drawing_area: '署名描画エリア。マウスまたはタッチを使用して署名を描いてください。',
  initials_drawing_area: 'イニシャル描画エリア。マウスまたはタッチを使用してイニシャルを描いてください。',
  kba: 'KBA',
  please_upload_an_image_file: '画像ファイルをアップロードしてください',
  must_be_characters_length: '{number}文字でなければなりません',
  must_be_valid_ssn: '有効なSSNである必要があります (XXX-XX-XXXX)',
  must_be_valid_ein: '有効なEINである必要があります (XX-XXXXXXX)',
  must_be_valid_email: '有効なメールアドレスである必要があります',
  must_be_valid_url: '有効なURLである必要があります (http://またはhttps://で始まる)',
  must_be_valid_zip: '有効なZIPである必要があります (XXXXX または XXXXX-XXXX)',
  must_contain_numbers_only: '数字のみを含む必要があります',
  must_contain_letters_only: '文字のみを含む必要があります',
  complete_all_required_fields_to_proceed_with_identity_verification: '本人確認を進めるには、すべての必須項目を入力してください。',
  verify_id: '本人確認',
  identity_verification: '本人確認',
  complete: '完了',
  fill_all_required_fields_to_complete: '完了するにはすべての必須項目を入力してください',
  sign_and_complete: '署名して完了',
  text: 'テキスト',
  by_clicking_you_agree_to_the: '"{button}" をクリックすることで、次に同意したことになります：',
  electronic_signature_disclosure: '電子署名に関する開示',
  esignature_disclosure: '電子署名開示',
  signature: '署名',
  initials: 'イニシャル',
  sign_on_the_touchscreen: 'タッチスクリーンで署名',
  approved: '承認済み',
  reviewed: '確認済み',
  other: 'その他',
  authored_by_me: '自分が作成',
  invite: '招待',
  email: 'メール',
  approved_by: '承認者',
  reviewed_by: '確認者',
  authored_by: '作成者',
  select_a_reason: '理由を選択',
  scan_the_qr_code_with_the_camera_app_to_open_the_form_on_mobile_and_draw_your_signature: 'QRコードをカメラアプリで読み取り、モバイルでフォームを開いて署名を描いてください',
  date: '日付',
  number: '数値',
  value_is_invalid: '無効な値です',
  verification_code_is_invalid: '認証コードが無効です',
  already_paid: 'すでに支払い済み',
  image: '画像',
  pay: '支払う',
  take_photo: '写真を撮る',
  number_phone_is_invalid: '{number} の電話番号は無効です',
  file: 'ファイル',
  digitally_signed_by: '電子署名者：',
  reason: '理由',
  select: '選択',
  checkbox: 'チェックボックス',
  multiple: '複数選択',
  radio: 'ラジオボタン',
  cells: 'セル',
  stamp: 'スタンプ',
  minimize: '最小化',
  payment: '支払い',
  phone: '電話',
  start_now: '今すぐ開始',
  continue: '続行',
  sign_now: '今すぐ署名',
  type_here_: 'ここに入力...',
  optional: '任意',
  option: 'オプション',
  appears_on: '表示ページ',
  page: 'ページ',
  select_your_option: 'オプションを選択',
  complete_hightlighted_checkboxes_and_click: 'ハイライトされたチェックボックスを完了し、クリックしてください',
  submit: '送信',
  next: '次へ',
  click_to_upload: 'クリックしてアップロード',
  or_drag_and_drop_files: 'またはファイルをドラッグ＆ドロップ',
  send_copy_via_email: 'メールでコピーを送信',
  download: 'ダウンロード',
  clear: 'クリア',
  redraw: '描き直す',
  draw_initials: 'イニシャルを描く',
  type_signature_here: 'ここに署名を入力',
  type_initial_here: 'ここにイニシャルを入力',
  form_has_been_completed: 'フォームが完了しました！',
  document_has_been_signed: 'ドキュメントが署名されました！',
  documents_have_been_signed: 'ドキュメントがすべて署名されました！',
  create_a_free_account: '無料アカウントを作成',
  powered_by: '提供元：',
  please_check_the_box_to_continue: '続行するにはボックスにチェックを入れてください。',
  open_source_documents_software: 'オープンソースのドキュメントソフトウェア',
  verified_phone_number: '電話番号を認証',
  country_code: '国番号',
  use_international_format: '国際形式を使用してください：+1xxx',
  six_digits_code: '6桁のコード',
  change_phone_number: '電話番号を変更',
  sending: '送信中...',
  resend_code: 'コードを再送信',
  verification_code_has_been_resent: '認証コードがSMSで再送信されました',
  please_fill_all_required_fields: 'すべての必須項目を入力してください',
  set_today: '今日の日付を設定',
  toggle_multiline_text: '複数行テキスト切り替え',
  draw_signature: '署名を描く',
  type_initial: 'イニシャルを入力',
  draw: '描く',
  type: '入力',
  type_text: 'テキストを入力',
  email_has_been_sent: 'メールが送信されました',
  processing: '処理中',
  pay_with_stripe: 'Stripeで支払う',
  reupload: '再アップロード',
  upload: 'アップロード',
  files: 'ファイル',
  signature_is_too_small_or_simple_please_redraw: '署名が小さすぎるか単純すぎます。もう一度描いてください。',
  browser_privacy_settings_block_canvas: 'ブラウザのプライバシー設定により、描画キャンバスの使用が制限されています。別のブラウザまたはデバイスを使用するか、署名するためにキャンバスをブロックするプライバシー設定を無効にしてください。',
  wait_countdown_seconds: '{countdown} 秒お待ちください',
  enter_screen_reader_mode: 'スクリーンリーダーモードを有効にする'
}

const i18n = { en, es, it, de, fr, pl, uk, cs, pt, he, nl, ar, ko, ja }

export default i18n
